import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-location",
  "use": "icon-icon-location-usage",
  "viewBox": "0 0 16.3 20.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.3 20.9\" id=\"icon-icon-location\"><title>资源 1</title><g id=\"icon-icon-location_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-location_OBJECTS\"><path d=\"M8.1,0A8.1,8.1,0,0,0,0,8.1c0,4.5,8.1,12.8,8.1,12.8s8.2-8.3,8.2-12.8A8.2,8.2,0,0,0,8.1,0Zm0,11.9a3.8,3.8,0,1,1,3.8-3.8A3.8,3.8,0,0,1,8.1,11.9Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-location.svg
// module id = 9Lce
// module chunks = 72